import axios from "axios";
// import router from './../../../router'

export const getGurus = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-gurus/" + payload)
            .then(response => {
                commit("SET_GURUS", response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(true);
            })
            .catch(errors => {
                resolve(false);
                // commit('SET_ERRORS_FORM_GURU', errors.data.errors);
            });
    });
};

export const getGurusPersekolah = ({ commit }, sekolahnya) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-gurus-persekolah/" + sekolahnya)
            .then(response => {
                commit("SET_GURUS_PERSEKOLAH", response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve("ok");
            })
            .catch(errors => {
                // commit('SET_ERRORS_FORM_GURU', errors.data.errors);
                reject("fail");
            });
    });
};

export const getGurusQueuePersekolah = ({ commit }, sekolahnya) => {
    return new Promise((resolve, reject) => {
        commit("SET_OVERLAY", true, { root: true });
        axios
            .get("/api/get-gurus-queue-persekolah/" + sekolahnya)
            .then(response => {
                commit("SET_GURUS_QUEUE_PERSEKOLAH", response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve("ok");
            })
            .catch(errors => {
                // commit('SET_ERRORS_FORM_GURU', errors.data.errors);
                reject("fail");
            });
    });
};

export const getGuruSolo = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-guru/" + payload)
            .then(response => {
                resolve(response.data);
                commit("SET_OVERLAY", false, { root: true });
            })
            .catch(e => {
                reject(e.response.status);
            });
    });
};

export const getOneGuruByNik = ({ commit }, nik) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-guru-by-nik/" + nik)
            .then(response => {
                resolve(response.data);
                commit("SET_OVERLAY", false, { root: true });
            })
            .catch(e => {
                reject(e.response.status);
            });
    });
};

export const storeGuru = ({ commit, dispatch }, guru) => {
    return new Promise((resolve, reject) => {
        commit("SET_OVERLAY", true, { root: true });
        let nama = guru.nama;
        axios
            .post("/api/tambah-guru", guru)
            .then(response => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                };
                dispatch("getGurusQueuePersekolah", guru.sekolah_id).then(
                    () => {
                        commit("SET_NOTIF", notif, { root: true });
                    }
                );
                resolve("success");
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateGuru = ({ commit, dispatch }, payload) => {
    let formData = new FormData();
    if (payload.is_approve) {
        let arr = [
            "id",
            "is_approve",
            "pin",
            "agama_id",
            "status_perkawinan",
            "no_telepon",
            "alamat_domisili",
            "gelar_depan",
            "gelar_belakang",
            "no_nuptk",
            "no_bpjs",
            "no_npwp",
            "email",
            "golda"
        ];
        for (const [key, value] of Object.entries(payload)) {
            if (arr.includes(key)) {
                formData.append(key, value);
            }
        }
    } else {
        let arr = [
            "jegur",
            "sekolah",
            "stapeg",
            "agama",
            "mugus",
            "gunduk",
            "latest_pangkat",
            "latest_berkala",
            "is_approve",
            "approve_text",
            "age",
            "pensiun",
            "kawin_text",
            "nama_gelar",
            "age_pensiun",
            "ttl",
            "jk_text",
            "togur",
            "created_at",
            "updated_at",
            "is_admin",
            "jensek_id"
        ];
        for (const [key, value] of Object.entries(payload)) {
            if (!arr.includes(key)) {
                formData.append(key, value);
            }
        }
    }

    return new Promise((resolve, reject) => {
        commit("SET_OVERLAY", true, { root: true });
        let nama = payload.nama;
        axios
            .post("/api/update-guru", formData)
            .then(response => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                };
                if (payload.is_admin) {
                    dispatch("getGurus", payload.jensek_id).then(() => {
                        commit("SET_NOTIF", notif, { root: true });
                    });
                } else if (payload.is_approve) {
                    dispatch("getGurusPersekolah", payload.sekolah_id).then(
                        () => {
                            commit("SET_NOTIF", notif, { root: true });
                        }
                    );
                } else {
                    dispatch(
                        "getGurusQueuePersekolah",
                        payload.sekolah_id
                    ).then(() => {
                        commit("SET_NOTIF", notif, { root: true });
                    });
                }
                resolve("success");
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const deleteGuru = ({ commit, dispatch }, guru) => {
    return new Promise((resolve, reject) => {
        commit("SET_OVERLAY", true, { root: true });
        let nama = guru.nama;
        axios
            .delete("/api/hapus-guru/" + guru.id)
            .then(response => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                };
                dispatch("getGurusQueuePersekolah", guru.sekolah_id).then(
                    () => {
                        commit("SET_NOTIF", notif, { root: true });
                    }
                );
                resolve("success");
            })
            .catch(e => {
                reject("fail");
            });
    });
};

export const updateFotoGuru = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("file", payload.file_foto);
    formData.append("guru_id", payload.guru_id);
    formData.append("guru_alias", payload.guru_alias);

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-foto-guru", formData)
            .then(response => {
                let notif = {
                    msg: "Foto Guru Berhasil diupdate~",
                    type: "update"
                };
                commit("SET_NOTIF", notif, { root: true });
                dispatch("getGuruSolo", payload.guru_id).then(() => {
                    resolve(response);
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

///////////////////////////////////

export const getPagus = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-pagus/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {});
    });
};

export const storePagu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/store-pagu", formData)
            .then(response => {
                let notif = {
                    msg: "Pangkat Guru Berhasil ditambahkan~",
                    type: "create"
                };
                dispatch("getPagus", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updatePagu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = [
        "status",
        "file_pangkat",
        "created_at",
        "updated_at",
        "status_text",
        "paone",
        "alasan_ditolak"
    ];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-pagu", formData)
            .then(response => {
                let notif = {
                    msg: "Pangkat Guru Berhasil diupdate~",
                    type: "update"
                };
                dispatch("getPagus", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const deletePagu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.paone.nama_gol + ", " + payload.paone.gol;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-pagu/" + payload.id).then(response => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            };
            dispatch("getPagus", payload.guru_id).then(res => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    });
};

///////////////////////////////////

export const getGabegus = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-gabegus/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {});
    });
};

export const storeGabegu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/store-gabegu", formData)
            .then(response => {
                let notif = {
                    msg: "Gaji Berkala Guru Berhasil ditambahkan~",
                    type: "create"
                };

                dispatch("getGabegus", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateGabegu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["paone", "file_berkala", "created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-gabegu", formData)
            .then(response => {
                let notif = {
                    msg: "Gaji Berkala Guru Berhasil diupdate~",
                    type: "update"
                };
                dispatch("getGabegus", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const deleteGabegu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.paone.nama_gol + ", " + payload.paone.gol;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-gabegu/" + payload.id).then(response => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            };
            dispatch("getGabegus", payload.guru_id).then(res => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    });
};

/////////////////////// honor

export const getRiwayatHonor = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-riwayat-honor-gurus/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {});
    });
};

export const storeRiwayatHonor = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/store-riwayat-honor-guru", formData)
            .then(response => {
                let notif = {
                    msg:
                        "Riwayat Pengangkatan Honor/Non PNS Berhasil ditambahkan~",
                    type: "create"
                };

                dispatch("getRiwayatHonor", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateRiwayatHonor = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["file_path", "created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-riwayat-honor-guru", formData)
            .then(response => {
                let notif = {
                    msg:
                        "Riwayat Pengangkatan Honor/Non PNS Berhasil diupdate~",
                    type: "update"
                };
                dispatch("getRiwayatHonor", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const deleteRiwayatHonor = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.no_sk;
    return new Promise((resolve, reject) => {
        axios
            .delete("/api/delete-riwayat-honor-guru/" + payload.id)
            .then(response => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                };
                dispatch("getRiwayatHonor", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            });
    });
};

///////////////////////////////////////// bedigus

export const getBedigus = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-bedigus/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {});
    });
};

export const storeBedigu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("guru_alias", payload.guru_alias);
    formData.append("guru_id", payload.guru_id);
    formData.append("berkas_id", payload.berkas_id);

    return new Promise((resolve, reject) => {
        axios
            .post("/api/store-bedigu", formData)
            .then(response => {
                let notif = {
                    msg: "Berkas Diri Guru Berhasil ditambahkan~",
                    type: "create"
                };
                dispatch("getBedigus", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateBedigu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("id", payload.id);
    formData.append("file", payload.file);
    formData.append("guru_alias", payload.guru_alias);
    formData.append("guru_id", payload.guru_id);
    formData.append("berkas_id", payload.berkas_id);

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-bedigu", formData)
            .then(response => {
                let notif = {
                    msg: "Berkas Diri Guru Berhasil diupdate~",
                    type: "update"
                };
                dispatch("getBedigus", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const deleteBedigu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.berkas.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-bedigu/" + payload.id).then(response => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            };
            dispatch("getBedigus", payload.guru_id).then(res => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    });
};

/////////////////////////////

export const getMugus = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-mugus/" + payload)
            .then(response => {
                commit("SET_SEMUA_MUGUS", response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve("ok");
            })
            .catch(e => {
                reject("fail");
            });
    });
};

export const getMuguPersekolah = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-mugu-persekolah/" + payload)
            .then(response => {
                commit("SET_MUGUS_PERSEKOLAH", response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve("ok");
            })
            .catch(e => {
                reject("fail");
            });
    });
};

export const getMuguPerguru = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-mugu-perguru/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {
                reject("fail");
            });
    });
};

export const ajukanMugu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/ajukan-mugu", formData)
            .then(response => {
                let notif = {
                    msg: "Mutasi Guru Berhasil dibuat~",
                    type: "update"
                };
                dispatch("getMuguPersekolah", payload.sekolah_id).then(res => {
                    dispatch("getGurusPersekolah", payload.sekolah_id).then(
                        r => {
                            resolve(r);
                            commit("SET_NOTIF", notif, { root: true });
                        }
                    );
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateMugu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("tgl_pengajuan_mutasi", payload.tgl_pengajuan_mutasi);
    formData.append("mugu_id", payload.mugu_id);
    formData.append("guru_id", payload.guru_id);
    formData.append("guru_alias", payload.guru_alias);
    formData.append("alasan_mutasi", payload.alasan_mutasi);
    formData.append("file", payload.file);
    formData.append("to", payload.to);

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-mugu", formData)
            .then(() => {
                let notif = {
                    msg: "Mutasi Guru Berhasil diperbaiki~",
                    type: "update"
                };
                dispatch("getMuguPersekolah", payload.sekolah_id).then(res => {
                    commit("SET_MUGUS_PERSEKOLAH", res.data);
                    commit("SET_NOTIF", notif, { root: true });
                    resolve("ok");
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const approveMugu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_guru;
    return new Promise((resolve, reject) => {
        axios
            .post("/api/approve-mugu", payload)
            .then(response => {
                let notif = {
                    msg: nama + " telah disetujui~",
                    type: "update"
                };
                dispatch("getMugus", payload.jensek_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                });
            })
            .catch(e => {
                reject("fail");
            });
    });
};

///////////////////////////////////////////////// bagikan

export const getGundukPersekolah = ({ commit }, sekolah_id) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/gurus-non-induk/" + sekolah_id)
            .then(response => {
                commit("SET_GUNDUKS_PERSEKOLAH", response.data);
                resolve("ok");
                commit("SET_OVERLAY", false, { root: true });
            })
            .catch(e => {
                reject("fail");
            });
    });
};

export const getGundukPersekolahAktif = ({ commit }, sekolah_id) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/gurus-non-induk-aktif/" + sekolah_id)
            .then(response => {
                commit("SET_GUNDUKS_PERSEKOLAH_AKTIF", response.data);
                resolve("ok");
                commit("SET_OVERLAY", false, { root: true });
            })
            .catch(e => {});
    });
};

export const hapusBagikan = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_guru;
    return new Promise((resolve, reject) => {
        axios
            .post("/api/hapus-bagikan", payload)
            .then(response => {
                let notif = {
                    msg: nama + " telah dihapus~",
                    type: "create"
                };
                dispatch("getGundukPersekolah", payload.sekolah_id).then(
                    res => {
                        let temp = {
                            sekolah_id: payload.sekolah_id,
                            tajar_id: payload.tajar_aktif_id
                        };
                        dispatch("rosek/getRosekPersekolah", temp, {
                            root: true
                        }).then(() => {
                            resolve("ok");
                            commit("SET_NOTIF", notif, { root: true });
                        });
                    }
                );
            })
            .catch(e => {});
    });
};

//////////////////////edugus

export const getEdugus = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-edugus/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {});
    });
};

export const storeEdugu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["edu", "file_ijazah", "created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/store-edugu", formData)
            .then(response => {
                let notif = {
                    msg: "Riwayat Pendidikan Berhasil ditambahkan~",
                    type: "create"
                };
                dispatch("getEdugus", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateEdugu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["edu", "file_ijazah", "created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-edugu", formData)
            .then(response => {
                let notif = {
                    msg: "Riwayat Pendidikan Berhasil diupdate~",
                    type: "update"
                };
                dispatch("getEdugus", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const deleteEdugu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.edu.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-edugu/" + payload.id).then(response => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            };
            dispatch("getEdugus", payload.guru_id).then(res => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    });
};

//////////////////////tutamgu

export const getTutamgus = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-tutamgus/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {});
    });
};

export const storeTutamgu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["tutam", "created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/store-tutamgu", formData)
            .then(response => {
                let notif = {
                    msg: "Tugas Tambahan Berhasil ditambahkan~",
                    type: "create"
                };
                if (response.data.exist) {
                    commit("SET_OVERLAY", false, { root: true });
                    resolve(response.data);
                } else {
                    dispatch("getTutamgus", payload.guru_id).then(res => {
                        resolve(res);
                        commit("SET_NOTIF", notif, { root: true });
                        commit("SET_OVERLAY", false, { root: true });
                    });
                }
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateTutamgu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["tutam", "created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-tutamgu", formData)
            .then(response => {
                let notif = {
                    msg: "Tugas Tambahan Berhasil diupdate~",
                    type: "update"
                };
                if (response.data.exist) {
                    commit("SET_OVERLAY", false, { root: true });
                    resolve(response.data);
                } else {
                    dispatch("getTutamgus", payload.guru_id).then(res => {
                        resolve(res);
                        commit("SET_NOTIF", notif, { root: true });
                        commit("SET_OVERLAY", false, { root: true });
                    });
                }
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const deleteTutamgu = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.tutam.tugas_tambahan;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-tutamgu/" + payload.id).then(response => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            };
            dispatch("getTutamgus", payload.guru_id).then(res => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    });
};

//////////////////////gunduks

export const getGunduks = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-gunduks/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {});
    });
};

export const ajukanGunduk = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .put("/api/ajukan-gunduk/" + payload.id)
            .then(response => {
                let notif = {
                    msg: "Permohonan berhasil diajukan~",
                    type: "update"
                };
                dispatch("getGunduks", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_OVERLAY", false, { root: true });
                    commit("SET_NOTIF", notif, { root: true });
                });
            })
            .catch(e => {});
    });
};

export const storeGunduk = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/store-gunduk", formData)
            .then(response => {
                let notif = {
                    msg: "Permohonan berhasil dibuat~",
                    type: "create"
                };
                dispatch("getGunduks", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateGunduk = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-gunduk", formData)
            .then(response => {
                let notif = {
                    msg: "Permohonan berhasil diupdate~",
                    type: "update"
                };
                dispatch("getGunduk", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const nonAktifGunduk = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_guru;
    return new Promise((resolve, reject) => {
        axios.post("/api/non-aktif-gunduk/", payload).then(response => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dinon aktifkan~",
                type: "update"
            };
            dispatch("getGundukPersekolah", payload.sekolah_id).then(res => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                let temp = {
                    sekolah_id: payload.sekolah_id,
                    tajar_id: payload.tajar_aktif_id
                };
                dispatch("rosek/getRosekPersekolah", temp, { root: true });
            });
        });
    });
};

export const batalGunduk = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/batal-gunduk/" + payload.id).then(response => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            };
            dispatch("getGunduks", payload.guru_id).then(res => {
                resolve(res);
                commit("SET_OVERLAY", false, { root: true });
                commit("SET_NOTIF", notif, { root: true });
            });
        });
    });
};

export const tolakBagikan = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.data.nama;

    return new Promise((resolve, reject) => {
        axios
            .post("/api/tolak-gunduk", payload.data)
            .then(response => {
                let notif = {
                    msg: nama + " berhasil ditolak~",
                    type: "create"
                };
                dispatch("getGundukPersekolah", payload.sekolah_id).then(
                    res => {
                        resolve(res);
                        commit("SET_NOTIF", notif, { root: true });
                    }
                );
            })
            .catch(e => {
                reject(e.response.data.errors);
                commit("SET_OVERLAY", false, { root: true });
            });
    });
};

export const approveGunduk = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }
    return new Promise((resolve, reject) => {
        axios
            .post("/api/approve-gunduk", formData)
            .then(response => {
                let notif = {
                    msg: "Guru non induk telah disetujui~",
                    type: "update"
                };
                dispatch("getGundukPersekolah", payload.sekolah_id).then(
                    res => {
                        resolve(res);
                        commit("SET_NOTIF", notif, { root: true });
                    }
                );
            })
            .catch(e => {
                reject(e.response.data.errors);
                commit("SET_OVERLAY", false, { root: true });
            });
    });
};

///////// approve berkas

export const ajukanBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios
            .post(
                "/api/ajukan-" +
                    payload.route +
                    "/" +
                    payload.id +
                    "/" +
                    payload.to
            )
            .then(response => {
                let notif = {
                    msg: nama + " berhasil diajukan~",
                    type: "update"
                };
                dispatch(payload.dispatch, payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {});
    });
};

export const approveBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios
            .put("/api/approve-berkas-" + payload.route + "/" + payload.id)
            .then(response => {
                let notif = {
                    msg: nama + " berhasil disetujui~",
                    type: "update"
                };
                dispatch(payload.dispatch, payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {});
    });
};

export const tolakBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        let notif = {
            msg: nama + " berhasil ditolak~",
            type: "delete"
        };
        dispatch(payload.dispatch, payload.guru_id).then(res => {
            resolve(res);
            commit("SET_NOTIF", notif, { root: true });
            commit("SET_OVERLAY", false, { root: true });
        });
    });
};

//////////////////////////////gukel

export const getGukelsPersekolah = ({ commit }, sekolahnya) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-gukels-persekolah/" + sekolahnya)
            .then(response => {
                commit("SET_GUKELS_PERSEKOLAH", response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve("ok");
            })
            .catch(errors => {
                reject("fail");
            });
    });
};

export const getSemuaGukels = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-semua-gukels/" + payload)
            .then(response => {
                commit("SET_SEMUA_GUKELS", response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve("ok");
            })
            .catch(errors => {
                reject("fail");
            });
    });
};

export const approveGukel = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_guru;
    return new Promise((resolve, reject) => {
        axios
            .put("/api/approve-gukel/" + payload.gukel_id)
            .then(response => {
                let notif = {
                    msg: nama + " telah disetujui~",
                    type: "update"
                };
                dispatch("getSemuaGukels", payload.jensek_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                });
            })
            .catch(e => {
                reject("fail");
            });
    });
};

////////////////sertifikasi

export const getSertifikasis = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-sertifikasis/" + payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(e => {});
    });
};

export const storeSertifikasi = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios
            .post("/api/store-sertifikasi", formData)
            .then(response => {
                let notif = {
                    msg: "Sertifikasi berhasil ditambahkan~",
                    type: "create"
                };

                dispatch("getSertifikasis", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const updateSertifikasi = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ["file_path", "created_at", "updated_at"];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }
    return new Promise((resolve, reject) => {
        axios
            .post("/api/update-sertifikasi", formData)
            .then(response => {
                let notif = {
                    msg: "Sertifikasi berhasil diupdate~",
                    type: "update"
                };
                dispatch("getSertifikasis", payload.guru_id).then(res => {
                    resolve(res);
                    commit("SET_NOTIF", notif, { root: true });
                    commit("SET_OVERLAY", false, { root: true });
                });
            })
            .catch(e => {
                commit("SET_OVERLAY", false, { root: true });
                reject(e.response.data.errors);
            });
    });
};

export const deleteSertifikasi = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nomor_sertifikat;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-sertifikasi/" + payload.id).then(() => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            };
            dispatch("getSertifikasis", payload.guru_id).then(res => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    });
};

///////////////////////////// pengaktifan

export const getPengaktifan = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-pengaktifan-guru/" + payload)
            .then(response => {
                commit("SET_OVERLAY", false, { root: true });
                resolve(response.data);
            })
            .catch(e => {
                reject("fail");
            });
    });
};
